import {
  BookOpenText as BookIcon,
  Ear as EarIcon,
  Microphone as MicrophoneIcon,
  Smiley as SmileyIcon,
  SmileyWink as WinkIcon,
  SmileyNervous as NervousIcon,
} from "@phosphor-icons/react";
import io from 'socket.io-client';

import Link from "next/link";

export default function HomePage() {
  return (
    <div className="px-6 py-10 pb-20 sm:px-10 md:px-14">
      <div className="text-center md:text-left">
        <div className="pb-2 text-4xl font-medium text-neutral-700">AI 아바타 상담사 테스트 서비스</div>
        <div className="pt-5">나의 감정에 반응하는 AI Avatar 상담사와 상황별 상담을 진행하세요 </div>

        <div className="md:px-10 pt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
          <ModelSection name="감정 반응 AI 상담사 시나리오" page="/base" iconClass={WinkIcon} />
        </div>
        <div className="md:px-10 pt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* <ModelSection name="인바운드 상담콜 시나리오 (실패)" page="/inbound-fail" iconClass={NervousIcon} /> */}
          <ModelSection name="인바운드 상담콜 시나리오" page="/inbound-ok" iconClass={SmileyIcon} />
        </div>
        <div className="md:px-10 pt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* <ModelSection name="아웃바운드 상담콜 시나리오 (실패)" page="/outbound-fail" iconClass={NervousIcon} /> */}
          <ModelSection name="아웃바운드 상담콜 시나리오" page="/outbound-ok" iconClass={SmileyIcon} />
        </div>
      </div>
    </div>
  );
}

type ModelSectionProps = {
  iconClass: any;
  name: string;
  page: string;
};

function ModelSection(props: ModelSectionProps) {
  return (
    <Link href={props.page}>
      <div className="hover:border-neutral-400 hover:ease-linear duration-200 flex w-full justify-center items-center rounded-lg border border-neutral-200 bg-white px-14 py-12 shadow">
        <props.iconClass size={40} />
        <div className="ml-6 text-2xl">{props.name}</div>
      </div>
    </Link>
  );
}
